import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { Typography } from '@mui/material';
import { PageLayout, PageHeader, ContentSection } from '../components/layout/PageLayout';
import { EnhancedCard } from '../components/layout/EnhancedCard';
import TasksPanel from '../components/tasks/TasksPanel';
import type { RootState } from '../store/store';
import AssignmentIcon from '@mui/icons-material/Assignment';

const TasksPage: React.FC = () => {
  const { user } = useSelector((state: RootState) => state.auth);
  const isAdmin = user?.roles?.includes('admin');

  // Redirect non-admin users
  if (!isAdmin) {
    return <Navigate to='/' replace />;
  }

  return (
    <PageLayout>
      <PageHeader icon={<AssignmentIcon />} title='Task Management' subtitle='View, monitor, and execute scheduled tasks' />

      <ContentSection>
        <EnhancedCard variant='outlined' sx={{ p: 3, mb: 4 }}>
          <Typography variant='body1' paragraph>
            This page allows administrators to view, monitor, and execute scheduled tasks. You can view task logs, force task execution, and
            enable/disable scheduled tasks.
          </Typography>
        </EnhancedCard>

        <TasksPanel />
      </ContentSection>
    </PageLayout>
  );
};

export default TasksPage;
